import { useMemo } from 'react';
import { useList } from '@hana/data';
import { AR_CUSTOMERS } from '../finance/fixtures';
import type { ArCustomer, IssuedInvoice, Receipt } from '../finance/types';
import { OUT_ROWS } from './inv';
import type { OutRow } from './invf';
import { RCP_ROWS, type RcpRow } from './rcp';

/** Công nợ theo khách: ưu tiên `/v1/finance/ar`; lỗi mạng / chưa đăng nhập → dữ liệu mẫu, 403 (noperm) → rỗng. */
export function useArSource(): readonly ArCustomer[] {
  const q = useList('finArCustomer', { limit: 500 });
  if (q.data) return q.data.items as readonly ArCustomer[];
  const code = (q.error as { code?: string } | null)?.code;
  return q.error && code !== 'noperm' ? AR_CUSTOMERS : [];
}

/** Hoá đơn đã xuất (tab "Đã xuất"): `/v1/finance/ar`; lỗi mạng / chưa đăng nhập → dữ liệu mẫu, 403 (noperm) → rỗng. Khách = tên khách thật (không có khoá danh bạ). */
export function useOutRows(): readonly OutRow[] {
  const q = useList('finIssuedInvoice', { limit: 500 });
  return useMemo(() => {
    if (q.data) return (q.data.items as readonly IssuedInvoice[]).map((i): OutRow => [i.no, i.date, i.customer, i.net, i.vat, i.signed, i.sent, i.period]);
    const code = (q.error as { code?: string } | null)?.code;
    return q.error && code !== 'noperm' ? OUT_ROWS : [];
  }, [q.data, q.error]);
}

/** Phiếu thu: `/v1/finance/payments`; lỗi mạng / chưa đăng nhập → dữ liệu mẫu, 403 (noperm) → rỗng. Chưa có dòng gắn debit / người duyệt (links rỗng). */
export function useRcpRows(): readonly RcpRow[] {
  const q = useList('finReceipt', { limit: 500 });
  return useMemo(() => {
    if (q.data) return (q.data.items as readonly Receipt[]).map((r): RcpRow => ({ no: r.no, date: r.date, cus: r.customer, bank: r.bank, amt: r.amount, cur: r.currency, links: r.links, memo: r.memo, by: r.maker, ap: r.approved, type: r.links.length ? 'inv' : 'cash', branch: '', apBy: '' }));
    const code = (q.error as { code?: string } | null)?.code;
    return q.error && code !== 'noperm' ? RCP_ROWS : [];
  }, [q.data, q.error]);
}
